// Class: starling.display.ButtonState

var $global = typeof window != "undefined" ? window : typeof global != "undefined" ? global : typeof self != "undefined" ? self : this

$global.Object.defineProperty(exports, "__esModule", {value: true});

var __map_reserved = {};

// Imports

var $hxClasses = require("./../../hxClasses_stub").default;

// Constructor

var ButtonState = function(){}

// Meta

ButtonState.__name__ = ["starling","display","ButtonState"];
ButtonState.prototype = {
	
};
ButtonState.prototype.__class__ = ButtonState.prototype.constructor = $hxClasses["starling.display.ButtonState"] = ButtonState;

// Init



// Statics


ButtonState.UP = "up"
ButtonState.DOWN = "down"
ButtonState.OVER = "over"
ButtonState.DISABLED = "disabled"

// Export

exports.default = ButtonState;


//////////////////
// WEBPACK FOOTER
// ./lib/_gen/starling/display/ButtonState.js
// module id = 294
// module chunks = 0